import { render, staticRenderFns } from "./PortalHeader.vue?vue&type=template&id=242e1f4c&scoped=true"
import script from "./PortalHeader.vue?vue&type=script&lang=js"
export * from "./PortalHeader.vue?vue&type=script&lang=js"
import style0 from "./PortalHeader.vue?vue&type=style&index=0&id=242e1f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242e1f4c",
  null
  
)

export default component.exports